
import { DEBUG } from '@src/DEBUG'; 
DEBUG.open ( '/app/main/map.index.ts' );

import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {RouterModule, Routes} from '@angular/router';

import {SharedModule} from '../../commons/shared.module';
import {MetadataDialogComponent} from './photogram/metadata-dialog/metadata-dialog.component';

import {MapComponent, TBAComponent} from './map.component';

import {LayersListComponent} from './list-views/layers.component';
import {ProcessingComponent} from './list-views/processing.component';
import {AppRoutes} from '../../commons/global';
import {PhotogramComponent} from './photogram/photogram.component';

import {ProjectSettingComponent} from './detail-views/project-setting.component';
import {TermsConditionDialogComponent} from './photogram/terms-condition-dialog/terms-condition-dialog.component';

import { GuideComponent } from './guide/guide.component';
import {PaymentComponent} from './photogram/payment/payment.component';
import { InspectionComponent } from './list-views/inspect.component';
import { ImageListManager } from './list-views/images.component';

import { PinViewer } from './detail-views/annots/pin.component';
import { LineViewer } from './detail-views/annots/line.component';
import { AreaComponent } from './detail-views/annots/area/area.component';
import { VolumeComponent } from './detail-views/annots/volume/volume.component';
import { MultiPoiComponent } from './detail-views/annots/multi-poi/multi-poi.component';
import { AgronoViewer } from './detail-views/annots/3rd_party/agronomeye.component';
import { DatumViewer } from './detail-views/annots/3rd_party/dataum.component';

import { CameraNavComponent } from './camera-nav.component';
import { PositionNavComponent } from './position-nav.component';
import { ImageViewer, ImageCell } from './detail-views/image/image.component';
import { GeoJsonViewer } from './detail-views/layers/geojson.component';
import { ProcessingDetailsComponent } from './detail-views/processing.component';
import { ShareComponent } from './detail-views/share.component';

import {TerrainCompareComponent} from './detail-views/terrain-compare/terrain-compare.component';
import {ScreenshotComponent} from './screenshot/screenshot.component';
import { AgroListComponent } from './list-views/3rd_party/agro.component';
import {LockCameraComponent} from './lock-camera/lock-camera.component';
import {FlyToLineComponent} from './detail-views/annots/fly-to-line/fly-to-line.component';
import {KeyboardNavigatorComponent} from './keyboard-navigator/keyboard-navigator.component';
import {FeatuerPropertiesViewerComponent} from './detail-views/layers/featuer-properties-viewer/featuer-properties-viewer.component';
import {CreditNotesComponent} from './credit-notes/credit-notes.component';
import {PlayerComponent} from './player/player.component';
import {EpsgcodeDialog} from '../../commons/dialogs/epsgcode/epsgcode-dialog.component';

import { PPListComponent } from './list-views/3rd_party/pp.component';
import { PPViewer } from './detail-views/annots/3rd_party/pp.component';
import { MapDataService } from '../../v2/commons/map-data.service';
import { LibraryComponent } from './list-views/library/library.component';
import { XsIdentityInterface } from '@src/app/xs/interfaces/identify.interface';
import { XsModule } from '@src/app/xs/xs.module';
import { Map2Component } from './map2.component';

const Routes: Routes = [
  {path: '', redirectTo: '/' + AppRoutes.MAIN_PROJECTS, pathMatch: 'full'},
  {
    path: ':projId', component: MapComponent,
    children: [
      {path: '', redirectTo: 'layers', pathMatch: 'full'},
      {path:'settings', component:ProjectSettingComponent,pathMatch:'full'},
      {path:'shares', component:ShareComponent,pathMatch:'full'},

      // annotation editors:
      {path: 'datum/:id', component: DatumViewer, pathMatch: 'full'},
      {path: 'agronomeye/:id', component: AgronoViewer, pathMatch: 'full'},
      {path: 'pp/:id', component: PPViewer, pathMatch: 'full'},
      {path: 'proc/:type/:id', component: ProcessingDetailsComponent, pathMatch: 'full'},
      {path: 'proc/:type/:id/:jid', component: ProcessingDetailsComponent, pathMatch: 'full'},
    
      {path: 'image/:id', component: ImageViewer, pathMatch: 'full'},
      {path: 'poi/:id', component: PinViewer, pathMatch: 'full'},
      {path: 'line/:id', component: LineViewer, pathMatch: 'full'},
      {path: 'area/:id', component: AreaComponent, pathMatch: 'full'},
      {path: 'volume/:id', component: VolumeComponent, pathMatch: 'full'},
      {path: 'multiPoi/:id', component: MultiPoiComponent, pathMatch: 'full'},
      {path: 'flyToLine/:id', component: FlyToLineComponent, pathMatch: 'full'},

      {path: 'geojson/:lat/:lng', component: GeoJsonViewer, pathMatch: 'full'},
      {path: 'featureProperties', component: FeatuerPropertiesViewerComponent, pathMatch: 'full'},
     // {path: 'images', component: ImageManager, pathMatch: 'full'},
     // {path: 'search', component: ProjectInpectComponent, pathMatch: 'full'},
     // {path: 'search/:annotId', component: ProjectInpectComponent, pathMatch: 'full'},
     // {path: 'layers', component: LayermanComponent, pathMatch: 'full'},
      {path: 'guide/:id', component: GuideComponent, pathMatch: 'full'},

      {path: 'photogram', component: PhotogramComponent, pathMatch: 'full'},
      {path: 'terrainCompare/:transformId', component: TerrainCompareComponent, pathMatch: 'full'},
      //{path: 'setting', component: ProjectSettingComponent, pathMatch: 'full'},
      
      {path: ':tabId', component: TBAComponent, pathMatch: 'full'},
      {path: '**', component: TBAComponent}

    ]
  }


];

DEBUG.log ( '/app/main/map.index.ts', 'module' );

@NgModule({
  imports: [
    FormsModule,
    CommonModule,
    SharedModule,
    XsModule,
    RouterModule.forChild(Routes)
  ],

  declarations: [
    MapComponent,  Map2Component, InspectionComponent,ImageListManager,ProjectSettingComponent,ImageCell,ShareComponent,AgroListComponent,
    TBAComponent,  PinViewer,LineViewer,CameraNavComponent, PositionNavComponent,ImageViewer,DatumViewer,AgronoViewer,
    GuideComponent, PhotogramComponent,MetadataDialogComponent, TermsConditionDialogComponent, TerrainCompareComponent, PaymentComponent,LayersListComponent, ProcessingComponent, LibraryComponent, VolumeComponent, AreaComponent,
    MultiPoiComponent, ScreenshotComponent, LockCameraComponent, FlyToLineComponent, KeyboardNavigatorComponent, FeatuerPropertiesViewerComponent, CreditNotesComponent, PlayerComponent,
    ProcessingDetailsComponent,PPListComponent,PPViewer, GeoJsonViewer
  ],
  providers:[
    MapDataService
  ],
  entryComponents: [MetadataDialogComponent, TermsConditionDialogComponent, PaymentComponent, EpsgcodeDialog]

})

export class MapModule implements XsIdentityInterface {

  __ID = XsIdentityInterface.__init(this);

}
